import React from 'react';
import { forEach as _forEach } from 'lodash';

export const DOC_TYPE_SALES_CONTRACT = '5b3346efb083130a6a36494c';
export const DOC_TYPE_DRIVERS_LICENSE = '5947e3c8e3f131058c3412d1';

export const getFileIconType = file => {
  switch (file.type || file.getType()) {
    case 'doc':
      switch (file.extension || file.getExtension()) {
        case 'pdf':
          return 'fal fa-file-pdf';

        case 'doc':
        case 'docx':
          return 'fal fa-file-word';

        case 'xls':
        case 'xlsx':
          return 'fal fa-file-excel';
      }
      break;

    case 'img':
      return 'fal fa-file-image';
  }

  return 'fas fa-file';
};

export const getDocSize = doc => {
  let size = 0;

  if ((doc.files && doc.files.length) || (doc.getFiles && doc.getFiles() && doc.getFiles().length)) {
    _forEach(doc.files || doc.getFiles(), file => {
      size += parseInt(file.file_size || file.getFileSize(), 10);
    });
  }

  if (!size) {
    return '-';
  }

  const i = Math.floor(Math.log(size) / Math.log(1024));
  return (size / 1024 ** i).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
};

export const docIcons = doc => {
  const types = [];
  const result = [];

  if ((doc.files && doc.files.length) || (doc.getFiles && doc.getFiles() && doc.getFiles().length)) {
    _forEach(doc.files || doc.getFiles(), file => {
      const fileType = getFileIconType(file);

      if (types.indexOf(fileType) === -1) {
        types.push(fileType);
        result.push(<i class={fileType} key={fileType} />);
      }
    });
  }

  return result;
};

export const docFirstFileName = doc => {
  if (doc.getFiles && doc.getFiles() && doc.getFiles().length) {
    return doc.getFiles()[0].getFileName();
  }

  if (doc.files && doc.files.length) {
    return doc.files[0].file_name;
  }

  return '';
};

export const docFileNames = doc => {
  const fileNames = [];

  if (doc.getFiles && doc.getFiles() && doc.getFiles().length) {
    _forEach(doc.getFiles(), docFile => {
      fileNames.push(docFile.getFileName());
    });
  } else if (doc.files && doc.files.length) {
    _forEach(doc.files, docFile => {
      fileNames.push(docFile.file_name);
    });
  }

  return fileNames;
};

export const docTemplateTypes = messages => {
  return [
    {
      label: messages.salesDoc.quote,
      value: 'quote',
    },
    {
      label: messages.salesDoc.invoice,
      value: 'invoice',
    },
    {
      label: messages.salesDoc.credit_note,
      value: 'credit_note',
    },
  ];
};
